/** Timestamp local del último recordatorio WhatsApp manual por turno. */
import AsyncStorage from '@react-native-async-storage/async-storage';

const reminderKey = (appointmentId: string) => `appointments.wa_reminder.v1.${appointmentId}`;

export async function getAppointmentReminderSentAt(appointmentId: string): Promise<string | null> {
  const v = await AsyncStorage.getItem(reminderKey(appointmentId));
  return v && v.length > 4 ? v : null;
}

export async function markAppointmentReminderSent(appointmentId: string): Promise<string> {
  const iso = new Date().toISOString();
  await AsyncStorage.setItem(reminderKey(appointmentId), iso);
  return iso;
}
